import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ReceiveLog } from '@webapp/models/ReceiveLog'
import { SimpleUserMock } from './user.factory'

export const ReceiveLogMock = Factory.Sync.makeFactory<ReceiveLog>({
  id: Factory.each(() => faker.random.number()),
  pass_quantity: Factory.each(() =>
    faker.random.number(10).toFixed(5).toString()
  ),
  fail_quantity: Factory.each(() =>
    faker.random.number(10).toFixed(5).toString()
  ),
  order_item: Factory.each(() => faker.random.number()),
  created_at: Factory.each(() => faker.date.recent(30).toISOString()),
  // received_at date prior to created_at date, formatted as: YYYY-MM-DD
  received_at: Factory.each(
    () =>
      faker.date
        .between(faker.date.recent(365), faker.date.recent(31))
        .toISOString()
        .split('T')[0]
  ),
  is_edited: false,
  created_by: SimpleUserMock.build(),
  total_quantity: Factory.each(() => faker.random.number()),
})
